import { Component, OnInit } from '@angular/core';
import { MaintenanceTask, PropertyEditModel } from '../Models/MaintenanceTask';
import { ValidationResult } from '../Services/import.service';
import { MaintenanceTasksService } from "./maintenance-tasks.service";
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { MAT_MOMENT_DATE_ADAPTER_OPTIONS, MAT_MOMENT_DATE_FORMATS, MomentDateAdapter } from "@angular/material-moment-adapter"
import { ActivatedRoute } from '@angular/router';
import { TenantService } from '../../../../Services/tenant.service';
import { AvaModule } from '../Models/AvaModule';
import { MatTabChangeEvent, MatTabGroup, MatTab } from "@angular/material/tabs";
import { MatFormField, MatLabel, MatInput, MatHint } from '@angular/material/input';
import { FormsModule } from '@angular/forms';
import { DatePipe } from '@angular/common';
import { MatCard, MatCardTitle, MatCardContent, MatCardActions } from '@angular/material/card';
import { MatAccordion, MatExpansionPanel, MatExpansionPanelHeader, MatExpansionPanelTitle, MatExpansionPanelDescription, MatExpansionPanelActionRow } from '@angular/material/expansion';
import { MatIcon } from '@angular/material/icon';
import { MatButton, MatIconButton } from '@angular/material/button';
import { MatCheckbox } from '@angular/material/checkbox';
import { MatSelect } from '@angular/material/select';
import { MatOption } from '@angular/material/autocomplete';
import { MatRadioGroup, MatRadioButton } from '@angular/material/radio';
import { MatChipSet, MatChip } from '@angular/material/chips';
import { JobLiveViewComponent } from '../../../../Jobs/job.liveview.component';
import { PascalToHumanPipe } from './pascal-to-human.pipe';

@Component({
    selector: 'aw-maintenance-tasks',
    templateUrl: './maintenance-tasks.component.html',
    styleUrls: ['./maintenance-tasks.component.less'],
    providers: [
        { provide: MAT_DATE_LOCALE, useValue: 'en-GB' },
        {
            provide: DateAdapter,
            useClass: MomentDateAdapter,
            deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS],
        },
        { provide: MAT_DATE_FORMATS, useValue: MAT_MOMENT_DATE_FORMATS },
    ],
    imports: [MatFormField, MatLabel, MatInput, FormsModule, MatTabGroup, MatTab, MatCard, MatChipSet, MatChip, MatCardTitle, MatCardContent, MatAccordion, MatExpansionPanel, MatExpansionPanelHeader, MatExpansionPanelTitle, MatExpansionPanelDescription, MatIcon, MatButton, MatCheckbox, MatSelect, MatOption, MatHint, MatExpansionPanelActionRow, MatIconButton, JobLiveViewComponent, MatCardActions, DatePipe, MatRadioGroup, MatRadioButton, PascalToHumanPipe]
})
export class MaintenanceTasksComponent implements OnInit {
  modules: AvaModule[] = [];
  tasks: MaintenanceTask[] = [];
  provisioningJob;
  tasksFilter;
  file: File;
  filename: string;
  busy: boolean;
  busyMessage: "Uploading file";
  fileError: string;
  filenameToDisplay: string;
  activeTabName: string = '';

  constructor(private readonly route: ActivatedRoute, private readonly tasksService: MaintenanceTasksService, private readonly tenantService: TenantService)
  {
  }

  ngOnInit() {
    this.route.queryParams
      .subscribe(params => {
        this.tasksFilter = params['filter'];
      });

    this.tenantService
      .getAllTenantModules(this.tenantService.selectedTenant.Value)
      .subscribe(modules => this.modules = modules.sort((a, b) => {
        if (a.Name < b.Name) {
          return -1;
        }
        if (a.Name > b.Name) {
          return 1;
        }
        return 0;
      }));

    this.tasksService
      .getTasks()
      .subscribe(tasks => this.tasks = tasks);
  }

  hasConfig(task: MaintenanceTask){
    return !!task?.EditModel?.PropertyEditModels && task.EditModel.PropertyEditModels.length > 0;
  }

  toggleShowConfig(task: MaintenanceTask){
    task.provisioningJob = null;
    
    if(!task.RunConfig){
      task.RunConfig = {};
    }
    if(this.hasConfig(task))
    {
      // For dropdown/radiobutton fields the backend serialises enum defaults as integers
      // which won't match the string option values — seed them from DefaultValue instead.
      task.EditModel.PropertyEditModels
        .filter(s => (s.ControlType === 'dropdown' || s.ControlType === 'radiobutton') && s.DefaultValue != null)
        .forEach(s => {
          if (!s.Values?.includes(task.RunConfig[s.PropertyName])) {
            task.RunConfig[s.PropertyName] = s.DefaultValue;
          }
        });
      task.showRunConfig = true;
    }
  }

  getAcceptedFileTypes(setting: PropertyEditModel) {
    if (setting.AdditionalAttributes) {
      return setting.AdditionalAttributes.toString();
    }
  }

  onSubmit(task: MaintenanceTask, settingsForm = null)
  {
    if(settingsForm && settingsForm.form.invalid){
      return;
    }
    this.tasksService.executeTask(task)
    .subscribe(j => {
      task.provisioningJob = j;
      task.history = null;
      task.showRunConfig = true;
    });
  }

  getHistory(task: MaintenanceTask){
    this.tasksService.getHistory(task)
      .subscribe(r=> task.history = r);
  }

  generateArray(obj: any, propertyName: string) {
    if(!obj[propertyName]) obj[propertyName] = [];
    return obj[propertyName];
  }

  generateDictionary(obj: any, propertyName: string){
    if(!obj[propertyName]) obj[propertyName] = {};
    return Object.keys(obj[propertyName]).filter(k => !k.startsWith("$"));
  }

  newArrayItem(value: any, key: string, setting: any) {
    value.push(key);
    setting.newItem = "";
  }

  newValuePair(dic: any, key: string, value: string, setting:any) {
    dic[key] = value.toString();
    setting.newKey = "";
    setting.newValue = "";
  }

    removeRow(targetObj: any[], rowKey: string) {
        var indexToDelete = targetObj.indexOf(rowKey, 0)
        if (indexToDelete > -1) {
            targetObj.splice(indexToDelete, 1);
        }
  }

  onTabChange(event: MatTabChangeEvent) {
    this.activeTabName = event.tab.textLabel === "All" ? "" : event.tab.textLabel;
  }

  filteredTasks(filter: string, tabFilter: string): MaintenanceTask[] {
    let returnTasks = this.tasks;
    if ((filter && filter !== "")) {
      returnTasks = returnTasks.filter(t => t.Name.toLowerCase().indexOf(filter.toLowerCase()) > -1);
    }
    if ((tabFilter && tabFilter !== "")) {
      returnTasks = returnTasks.filter(t => t.Categories?.includes(tabFilter));
    }

    return returnTasks;
  }

  taskCategories() {
    return this.tasks.flatMap(t => t.Categories ?? []).filter((v, i, a) => a.indexOf(v) === i)
        .filter(c => c.trim().length > 0);
  }

  upload(e: any, task: MaintenanceTask) {
    let files: FileList = e.target.files;
    this.file = files[0];
    this.filenameToDisplay = '';
    this.filename = this.file.name;
    this.busy = true;
    this.busyMessage = 'Uploading file';
    this.fileError = null;
    this.tasksService.uploadFile(this.file, task).subscribe((result: ValidationResult) => {
      this.busy = false;
      if (result.Success) {
        this.filenameToDisplay = this.filename;
        task.RunConfig.FileId = result.Model;
      }
      else {
        this.filenameToDisplay = result.Errors.toString();
      }
    });
  }

  downloadTemplate(task: MaintenanceTask) {
    this.tasksService.downloadTemplate(task);
  }
}
